export const isResumePersonalizationUiEnabled =
  process.env.NEXT_PUBLIC_RESUME_PERSONALIZATION_ENABLED === "true";
